import { get } from 'lodash-es';

import type { AdminState } from './admin.types';
import type { RootState } from 'store/root-state';

export const selectIsAllFeaturesEnabled = (state: AdminState): boolean => state?.isAllFeaturesEnabled ?? false;

export const selectAdminIsAllFeaturesEnabled = (state: RootState): boolean => selectIsAllFeaturesEnabled(get(state, 'admin'));
